export default __webpack_public_path__ + "static/media/site_screenshot_3.8fdf170c.png";